import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function KulturnaZnamenitostIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="KulturnaZnamenitostIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="#FFFFFF" d="M76.9,66.6V40.5h5V18.9H18.1v21.6h5v26.1H18v12.2h64V66.6H76.9z" />
      <path fill="#3CAA78" d="M73.1,70.4V36.7h5v-14h-9.4V32h-6.2v-9.3h-9.4V32h-6.2v-9.3h-9.4V32h-6.2v-9.3h-9.4v14h5v33.7h-5.1V75h56.4
	v-4.6H73.1z M54.5,70.4h-9V58h9V70.4z"/>
    </svg>
  </SvgIcon>
}

export default KulturnaZnamenitostIcon;
